import { Component } from '@angular/core';

@Component({
    selector: 'app-blank-tank-icon',
    templateUrl: './blank-tank-icon.component.svg',
    styleUrls: ['./blank-tank-icon.component.scss']
})
export class BlankTankIconComponent
{

    constructor() { }
}
